/**
 * maxWidth/maxHeight 와 현재 그려진 이미지 요소의 너비/높이 중 작은 값으로 이미지 요소의 높이를 고정하는 함수
 *
 * XXX: 이미지의 ratio 값을 받아 width/height가 더 정확하게 aspect fit이 되게 하면 좋을듯합니다.
 * 지금은 이미지에 이벤트가 붙어있다면 이미지 영역이지만 그려지지 않는 부분도 이벤트를 받는 문제가 있습니다.
 */
export function fixImageElementSize({
  imgElement,
  maxWidth,
  maxHeight,
}: {
  imgElement: HTMLImageElement;
  maxWidth: number;
  maxHeight: number;
}) {
  const imgElementRect = imgElement.getBoundingClientRect();
  const fitMaxWidth = Math.min(maxWidth, imgElementRect.width);
  const fitMaxHeight = Math.min(maxHeight, imgElementRect.height);
  imgElement.style.width = `${fitMaxWidth}px`;
  imgElement.style.height = `${fitMaxHeight}px`;
  imgElement.setAttribute('data-fixed-width', String(fitMaxWidth));
  imgElement.setAttribute('data-fixed-height', String(fitMaxHeight));
}
